import { EnvConfig } from '@bn/primitives';

export const environment: EnvConfig = {
  develop: false,
  production: true,
  aiGatewayApiUrl: "https://mc-irwg9j3ut3.bunny.run",
  apiDocsBunnyUrl: "https://bunny.net/docs",
  apiEdgeDbLiteUrl: "https://api.testfluffle.net/database",
  apiMcUrl: "https://api-mc-stage.opsbunny.net",
  apiUrl: "https://testfluffle.net/api",
  apiWsUrl: "wss://testfluffle.net/api",
  appVersion: "DASH-3904",
  braintreePaymentOptions: "paypal,card,googlePay,applePay".split(','),
  captchaWidgetChallengeUrl: "https://cap.stg.bunnyplatform.net/edcbd78d87/",
  cdnLoggingReportApiUrl: "https://logging-report-api.bunny.net",
  cdnLogsApiUrl: "https://logging.bunnycdn.com",
  cdnOriginErrorLogsUrl: "https://cdn-origin-logging.testfluffle.net",
  changelogSubscriptionApiUrl: "https://changelog-rss-feed.bunny.net",
  computeDebuggerIframeUrl: "https://bunny-devtools-new.b-cdn.net/js_app.html",
  computeDebuggerWssHost: "scripting-sandbox-dns-core.bunny.net:8020",
  computeScriptingApiUrl: "https://scripting-sandbox-dns.bunny.net/api/Script",
  computeScriptingTemplatesApiUrl: "https://scripting-templates.b-cdn.net",
  computeScriptingTestApiUrl: "https://cdn-script-testing.fluffleinfra.net",
  dnsLogsApiUrl: "https://dns-logging.bunny.net",
  edgeStorageApiUrl: "https://storage.testfluffle.net",
  googlePayMerchantId: "",
  iframeBetaMediaDeliveryUrl: "https://player.flufflemedia.net",
  iframeMediaDeliveryUrl: "https://iframe.flufflemedia.net",
  libsUrl: "https://panel-production-libs.b-cdn.net",
  liveStreamRtmpIngestUrl: "rtmp://global.rtmp.flufflemedia.net/live",
  liveUrl: "https://dash.testfluffle.net",
  loqateKey: "NE21-MT64-ZR36-AN12",
  mcLoggingUrl: "https://mc-logging.testfluffle.net",
  mcRegistryHost: "registry.bunny.net",
  mcWsUrl: "mc-logging.testfluffle.net",
  mixPanelToken: "9bf8d5e7357a019b2b50be68cf976235",
  posthogApiHost: "https://posthog2.fluffleinfra.net",
  posthogToken: "phc_x3EqlhW0L1XJarYJUfZAEdBa0lcSuyZjD3lh4qDfSxb",
  s3AllowedRegionCodes: "DE,SE".split(','),
  scriptingWsUrl: "scripting-logging.testfluffle.net",
  shieldLogsUrl: "https://waf-logging.bunny.net",
  statusUrl: "https://status.bunny.net",
  streamApiUrl: "https://video.testfluffle.net",
  streamStatisticsApiUrl: "https://testfluffle.net/api/stream/analytics",
  supportBunnyUrl: "https://support.bunny.net",
  surveysApiUrl: "https://surveys-api-staging-soncm.bunny.run",
  toolsUrl: "https://tools.bunny.net",
};
